import React, { useState, useEffect } from 'react';
import arrow1 from "../Images/Group 2069/Group 2069.png";

// Images (optional, currently commented)
// import strategywebsiterf from '../Images/Strategy/strategywebsiterf.png';
// import graphicImage from '../Images/GraphicDesign/graphicstrategy.png';
// import webImage from '../Images/Website/webstrategy.png';
// import motionImage from '../Images/Motion/motionstrategy.png';
// import socialImage from '../Images/Social/socialstrategy.png';
// import appImage from '../Images/App/appstrategy.png';
// import soundImage from '../Images/Sound/soundstrategy.png';
// import aiImage from '../Images/AI/aistrategy.png';

// Gifs
const gif1 = require("../Images/gif/gif1.mp4");
const gif2 = require("../Images/gif/gif2.mp4");
const gif3 = require("../Images/gif/gif3.mp4");

const gifList = [gif1, gif2, gif3];

const strategySections = [
  {
    title: "Strategy",
    description: "Whether you're a startup, D2C brand, enterprise, or government initiative, our strategy scales with your ambitions. With our proprietary models and AI-integrated systems, Red Fibre delivers clarity, consistency, and creative impact — every step of the way.",
    // image: strategywebsiterf
  },
  {
    title: "Graphic Design",
    description: "From product launches to rebrands, our design strategy adapts to every stage of your brand’s journey. We use modular creative systems that grow with you and align perfectly across platforms.",
    // image: graphicImage
  },
  {
    title: "Website Creation",
    description: "Our web strategies are built for conversion and longevity — combining UI/UX thinking, performance optimization, and scalable backend structures for evolving business goals.",
    // image: webImage
  },
  {
    title: "Motion & Video",
    description: "Whether it's for social reels or branded explainers, our motion strategy ensures consistent storytelling flow, optimised video formats, and on-brand emotional tones.",
    // image: motionImage
  },
  {
    title: "Social Media",
    description: "Social strategies tailored to your audience behavior, built around engagement cycles and platform-native creativity. We plan for trends, but design for timeless interaction.",
    // image: socialImage
  },
  {
    title: "App Creation",
    description: "From MVP to full-scale apps, our strategy accounts for user adoption, feature scaling, and technology stack evolution — ensuring business alignment at every build stage.",
    // image: appImage
  },
  {
    title: "Sound Design",
    description: "Sound strategy integrates mood, message, and memorability — whether it's for UI feedback, branded music scores, or immersive sound beds in your campaigns.",
    // image: soundImage
  },
  {
    title: "AI, AR & VR",
    description: "We architect next-gen brand experiences using AI and immersive tech. From data-personalized flows to interactive AR layers, our strategy aligns future-thinking with current goals.",
    // image: aiImage
  }
];

function StrtMain2({ service }) {
  const [randomGif, setRandomGif] = useState(getRandomGif());

  function getRandomGif() {
    const randomIndex = Math.floor(Math.random() * gifList.length);
    return gifList[randomIndex];
  }

  useEffect(() => {
    setRandomGif(getRandomGif());
  }, []);

  const filteredSections = service
    ? strategySections.filter((item) => item.title === service)
    : strategySections;

  return (
    <>
      {filteredSections.map((item, index) => (
        <div className='strtMain2' key={index}>
          <div className='wfyt2'>
            <h2>Built for Scalability</h2>
            <p>{item.description}</p>
          </div>

          <div className="wfy">
            <img src={item.image} alt={item.title} />
            <div className="wfyt">
              <p>
                LET THIS {item.title.toUpperCase()} SOLUTION <br />
                WORK FOR YOU, EVERY WEEK.
              </p>
              <button className="wfy-btn">Learn more</button>
            </div>
          </div>

          <div className="wwc">
            <h1 className='dsd'>LET’S CONNECT TO GET YOUR DESIRED SERVICE DONE</h1>
            <div className="cu">
              <video width="640" height="360" className='cuImg' autoPlay loop muted>
                <source src={randomGif} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              <div className="lm-btn em-btn strt-btn">
                <button className="lm em">
                  Contact Us
                  <div className="arrows em-arr">
                    <img src={arrow1} alt="arrow1" className="arrow1" />
                    <img src={arrow1} alt="arrow1" className="arrow2" />
                  </div>
                </button>
                <div className="btn-r"></div>
                <div className="btn-w"></div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}

export default StrtMain2;
